<template>
  <div class="">

    <!--wrapper start-->
    <div class="wrapper home-default-wrapper">
      <!--== Start Preloader Content ==-->
      <div class="preloader-wrap" v-if="showLoader">
        <div class="preloader">
          <div class="text-center text-danger my-2">
              <img class="img-loading2" src="../../assets/img/logo-daring.png" alt="Logo"/><br>
              <b-spinner class="align-middle"></b-spinner>
          </div>
        </div>
      </div>
      <!--== End Preloader Content ==-->

      <content-header></content-header>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
</style>

<script>
  // import TopNavbar from "./SampleNavbar.vue";
  import ContentHeader from "./Header.vue";
  import ContentFooter from "./SampleFooter.vue";
  import DashboardContent from "./Content.vue";
  import { EventBus } from '@/eventBus.js'
  // import MobileMenu from "./MobileMenu";
  export default {
    components: {
      // TopNavbar,
      ContentFooter,
      DashboardContent,
      // MobileMenu,
      ContentHeader
    },
    data() {
      return {
        showCanvasMobile: false,
        stickyHeader: false,
        showLoader: false,
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
			EventBus.$on('showLoader', (val) => {
				if (val) {
          this.showLoader = true
				}
			})
      EventBus.$on('hideLoader', (val) => {
        if (val) {
          setTimeout(() => this.showLoader = false, 2000);
        }
      })
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    mounted () {
    },
    methods: {
      toggleCanvasMobile() {
        this.showCanvasMobile = !this.showCanvasMobile
      },
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      handleScroll () {
        if (window.pageYOffset > 150) {
          this.stickyHeader = true
        } else {
          this.stickyHeader = false
        }
      }
    }
  };
</script>
